import Observable from './observable';
export default function take(count, stream) {
    if (count <= 0) {
        return Observable.empty();
    }
    return new Observable(function factory(observer) {
        let isComplete = false;
        let isAsync = false;
        let index = -1;
        // tslint:disable-next-line:ter-prefer-arrow-callback
        const subscription = stream.subscribe({
            next(value) {
                // tslint:disable-next-line:no-increment-decrement
                isComplete = ++index >= count - 1;
                observer.next(value);
                if (isComplete) {
                    if (isAsync) {
                        subscription.unsubscribe();
                    }
                    observer.complete();
                }
            },
            error(error) {
                observer.error(error);
            },
            complete() {
                observer.complete();
            },
        });
        if (isComplete) {
            subscription.unsubscribe();
        }
        isAsync = true;
        return function unsubscribe() {
            if (!isComplete) {
                subscription.unsubscribe();
            }
        };
    });
}
//# sourceMappingURL=take.js.map